import { CustomAlertFragment, FooterDisclaimerItemFragment } from './fragments';
import gql from 'graphql-tag';

export const SourceInvestorUpdateTeaser = gql`
	fragment SourceInvestorUpdateTeaser on InvestorUpdate {
		title
		subtitle
		thumbnail {
			asset {
				url
				altText
			}
		}
	}
`;

export const SourceInvestorUpdate = gql`
	fragment SourceInvestorUpdate on InvestorUpdate {
		title
		subtitle
		thumbnail {
			asset {
				url
				altText
			}
		}
		coverMedia {
			mediaItems {
				thumbnail {
					asset {
						url
					}
				}
			}
		}
		updateBody: updateBodyRaw
		disclaimer: disclaimerRaw
		keyTakeawaysSection {
			heading
			summary
		}
	}
`;

export const ArticleTeaser = gql`
	fragment ArticleTeaser on Article {
		_createdAt
		_id
		isInvestorUpdate
		sourceInvestorUpdate {
			...SourceInvestorUpdateTeaser
		}
		slug {
			current
		}
		title
		subtitle
		abstract
		date
		showNewBadge
		author {
			_id
			name
		}
		category {
			_id
			name
			description
			slug {
				current
			}
		}
		coverImage {
			asset {
				url
				altText
			}
		}
	}
	${SourceInvestorUpdateTeaser}
`;

export const RelatedArticlesSectionFragment = gql`
	fragment RelatedArticlesSectionFragment on RelatedArticles {
		sectionHeading
		backgroundColor {
			hex
		}
		relatedArticles {
			...ArticleTeaser
		}
	}
	${ArticleTeaser}
`;

export const FullArticleFragment = gql`
	fragment FullArticleFragment on Article {
		_createdAt
		customArticleAlert {
			...CustomAlertFragment
		}
		slug {
			current
		}
		date
		isInvestorUpdate
		sourceInvestorUpdate {
			...SourceInvestorUpdate
		}
		title
		subtitle
		abstract
		author {
			name
		}
		category {
			name
			slug {
				current
			}
		}
		coverImage {
			asset {
				url
				altText
			}
		}
		hideCoverImage
		lead
		keyTakeawaysSection {
			heading
			summary
		}
		body: bodyRaw
		footnotes: footnotesRaw
		footerDisclaimers {
			...FooterDisclaimerItemFragment
		}
		recommended {
			...ArticleTeaser
		}
		addEmailCaptureCta
		emailCapturePrompt
		display_microfeedback
	}
	${SourceInvestorUpdate}
	${ArticleTeaser}
	${CustomAlertFragment}
	${FooterDisclaimerItemFragment}
`;

export const BlogCategoryQuery = gql`
	query BlogCategory($categorySlug: [String!]) {
		allBlogCategory(where: { slug: { current: { in: $categorySlug } } }) {
			_id
			name
			description
			slug {
				current
			}
		}
	}
`;

export const BlogsByCategoryQuery = gql`
	query BlogsByCategory($categorySlug: String!, $limit: Int) {
		allArticle(
			where: { _: { is_draft: false }, category: { slug: { current: { eq: $categorySlug } } } }
			sort: { date: DESC }
			limit: $limit
		) {
			...ArticleTeaser
		}
	}
	${ArticleTeaser}
`;

export const BlogArticleBySlugWithDraftsQuery = gql`
	query ArticleBySlugWithDrafts($slug: String!) {
		allArticle(where: { _: { is_draft: true }, slug: { current: { eq: $slug } } }) {
			_id
			...FullArticleFragment
		}
	}
	${FullArticleFragment}
`;

export const BlogArticleBySlugQuery = gql`
	query ArticleBySlug($slug: String!) {
		allArticle(where: { _: { is_draft: false }, slug: { current: { eq: $slug } } }) {
			_type
			...FullArticleFragment
		}
	}
	${FullArticleFragment}
`;

export const BlogLandingQuery = gql`
	query BlogLanding {
		allBlogLanding {
			_id
			title
			summary
			featuredPosts {
				...ArticleTeaser
			}
			pageComponents {
				__typename
				... on ArticlesSeries {
					_key
					_type
					seriesLabel
					seriesHeading
					seriesSubheading
					subheadingLink
					subheadingLinkText
					seriesPosts {
						...ArticleTeaser
					}
				}
				... on BlogLandingCta {
					_key
					_type
					ctaHeading
					ctaCopy
					ctaLinkUrl
					ctaLinkText
				}
				... on BlogFeaturedCategories {
					_key
					_type
					featuredCategories {
						name
						description
						slug {
							current
						}
					}
				}
			}
		}
	}
	${ArticleTeaser}
`;
